import { GtagActionItem, GtagProductActions } from '~/modules/aatrium-gtm'
import { event } from '~/modules/aatrium-gtm/helpers'

export function sendGtagProductEvent (eventName: GtagProductActions, params: GtagActionItem): void {
  event(eventName, params)
}
